export const transition = {
    duration: .25,
    ease: [.56, .03, .12, 1.04]
};

export const variants = {
    hideMenu: {
        opacity: 0,
        y: '101%',
        boxShadow: '0 -2px 5px rgba(0,0,0,0)'
    },
    showMenu: {
        opacity: 1,
        y: 0,
        boxShadow: '0 -2px 5px rgba(0,0,0,.1)'
    }
}